import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DeclinedOperation } from '@quorum/models/xs-resource';
import { BrowserControlCommunicationService } from '@applications/sha-services';

@Component({
  selector: 'svc-declined-ops-card',
  templateUrl: './declined-ops-card.component.html',
  styleUrls: ['./declined-ops-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeclinedOpsCardComponent implements OnInit {
  @Input() declinedOperation: DeclinedOperation;
  constructor(public browserControlCommunicationService: BrowserControlCommunicationService) {}

  ngOnInit() {}
}
